import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-terms-conditions',
  templateUrl: './terms-conditions.component.html',
  styleUrls: ['./terms-conditions.component.scss']
})
export class TermsConditionsComponent implements OnInit {
  activeTab: 'general' | 'customer' | 'vendor' = 'general';

  ngOnInit(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  setTab(tab: 'general' | 'customer' | 'vendor'): void {
    this.activeTab = tab;
  }
}
